
import './style.less'

import { h } from 'preact'
import { useRef } from 'preact/hooks'
import { ButtonText } from '@components/button'
import { withHydration } from '@util/hydrate'
import { lerp, easeInOutQuad } from '@util/transition'
import { useScrollYPosition } from '@util/useScrollPosition'
import classnames from 'classnames'


const ScrollHeader = ({ title, meta = [], link }) => {

	const y = useScrollYPosition()
	const ref = useRef()
	const rect = ref.current && ref.current.getBoundingClientRect()
	const percentScrolled = rect && rect.bottom ? y/rect.bottom : 0

	const style = (rect && rect.bottom >= -100) ? {
		transform: `translateY(${y/2}px)`,
		opacity: lerp(1, 0, 
			easeInOutQuad(Math.min(percentScrolled/2, 1))
		)
	} : {}

	const button = link && <ButtonText class="margin-0" {...link}>{link.title}</ButtonText>
	const metaItems = [meta].flat(1).map(x => x.trim()).filter(Boolean) // convert to flat array
	button && metaItems.push(button)

	const metaClasses = classnames(
		(meta && !link) && 'fade',
		'scroll-header__meta__item'
	)

	return <section class="scroll-header margin-top--large">
		<div ref={ref} className="scroll-header__inner" style={style}>
			<h1 class="text--xx-large">{title}</h1>
			{ (metaItems.length || '') && <div class="scroll-header__meta">
				{metaItems.map(item => {
					return <div class={metaClasses}>{item}</div>
				})}
			</div> }
		</div>
	</section>

}


export default withHydration(ScrollHeader)